<!--
 * @Author: lijh(¯﹃¯*)
 * @Date: 2023-12-12 09:55:58
 * @LastEditors: lijh(¯﹃¯*)
 * @LastEditTime: 2024-03-07 14:57:54
 * @Description: description
-->
<template>
  <div>
    <common-dialog
      v-dialog-drag
      center
      :width="hasMembers ? '90%' : '80%'"
      :border="false"
      :close-on-click-modal="false"
      :visible="dialogVisible"
      @close="changePostCreateVisible(false)"
      class="spec-dialog"
    >
      <div slot="title" class="title-wrapper">
        <span class="title">
          {{ title }}
        </span>
        <span class="tips">
          {{ tips }}
        </span>
      </div>

      <div class="content-panel">
        <div
          class="left-panel"
          :style="hasMembers ? 'width: 70%' : 'width: 100%'"
        >
          <article-major-content
            ref="majorContent"
            :hasCaseShare="hasCaseShare"
            :hasMembers="hasMembers"
            :hasAttachment="hasAttachment"
          />
        </div>

        <div v-if="hasMembers" class="right-panel" style="width: 30%">
          <article-member-invite ref="memberContainer" :participant="members" />
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <common-button
          @click="changePostCreateVisible(false)"
          class="operation-btn"
          type="cancel"
          >取消</common-button
        >
        <common-button
          v-if="hasDraftBtn"
          @click="handleSavePostDraft"
          type="warn"
          class="operation-btn"
          >存为草稿</common-button
        >
        <common-button
          @click="hasParticipant"
          type="primary"
          class="operation-btn"
          >发布
        </common-button>
        <common-button
          class="operation-btn"
          type="primary"
          v-if="hasMembers"
          @click="handleAddMember"
        >
          勾选参与人
        </common-button>
        <el-switch v-model="dialogData.urgency" active-text="加急发布">
        </el-switch>
      </span>
    </common-dialog>

    <participant-drawer
      v-if="dialogVisible"
      :visible.sync="selectMemberVisible"
      @callback="handleCallback"
    >
    </participant-drawer>

    <common-dialog
      class="protocol-dialog"
      title="网站内容访问保密要求"
      width="50%"
      :visible.sync="protocolVisible"
    >
      <div v-html="protocol"></div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="protocolVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSavePostInfo">同 意</el-button>
      </span>
    </common-dialog>
    <animation :loadingDataVisible="isLoading" :loadingText="loadingText" />
  </div>
</template>

<script>
import { Message } from "element-ui";
import { articleMixin } from "../../pages/mixins/articleMixin";
import { encryptionValue, decryptionValue } from "@/utils/CryptoJS.js";
import ArticleMajorContent from "../article/ArticleMajorContent";
import ArticleAttachmentUpload from "../article/ArticleAttachmentUpload";
import ArticleMemberInvite from "../article/ArticleMemberInvite";
import ParticipantDrawer from "./ParticipantDrawer";
import cookie from "@/utils/cookie";
import http from "@/utils/axios";
import animation from "@/components/loading/animation";

export default {
  name: "PostCreate",
  components: {
    ParticipantDrawer,
    ArticleMemberInvite,
    ArticleAttachmentUpload,
    ArticleMajorContent,
    animation
  },
  mixins: [articleMixin],

  props: {
    defaultProps: {
      children: "children",
      label: "label"
    },

    hasAttachment: {
      type: Boolean,
      default: false
    },

    hasMembers: {
      type: Boolean,
      default: false
    },

    //优先级
    priorityTpCode: {
      type: String,
      default: null
    },

    hasDraftBtn: {
      type: Boolean,
      default: true
    },

    hasCaseShare: {
      type: Boolean,
      default: false
    },

    baseUrl: {
      type: String,
      default: null
    },

    title: {
      type: String,
      default: "新建文章"
    },

    visible: {
      type: Boolean,
      default: false
    },
    memberTips: {
      type: Boolean,
      default: false
    },
    showProtocol: {
      type: Boolean,
      default: false
    },

    tips: {
      type: String,
      default: "tips"
    },

    //发布信息的类型
    contentType: {
      type: String,
      default: "文章"
    }
  },
  data() {
    return {
      //筛选节点的条件
      filterText: null,
      finalMemberData: [],
      treeData: [],
      memberData: [],
      //参与人
      participant: [],
      members: [],
      dialogData: {},
      protocolVisible: false,
      selectMemberVisible: false,
      dialogVisible: false,
      isLoading: false,
      treeLoading: false,
      deptPower: false,
      systemPower: false,
      superPower: false,
      loadingText: "保存中",

      discussAttachmentCode: "001-042"
    };
  },

  created() {
    this.systemPower = this.$store.state.userPowerStore.systemPower;
    this.superPower = this.$store.state.userPowerStore.superPower;
    this.deptPower = this.$store.state.userPowerStore.deptPower;
  },
  computed: {
    protocol() {
      // console.log("加密===", encryptionValue(window.config.protocol));
      // console.log("解密===", decryptionValue(window.config.protocol));
      return decryptionValue(window.config.protocol);
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal;
      if (newVal && this.hasMembers) {
        this.$nextTick(args => {
          this.$refs.memberContainer.initData();
        });
      }
    },

    //更新外面传入的值
    dialogVisible(newVal) {
      this.$emit("update:visible", newVal);
      if (!newVal) {
        this.selectMemberVisible = false;
      }
    }
  },

  methods: {
    //校验参数
    validateDialogForm() {
      let flag = true;
      if (
        (!this.dialogData.postTitle || !this.dialogData.postTitle.trim()) &&
        flag
      ) {
        Message.error({ message: "文章标题不能为空" });
        flag = false;
      }
      if (
        (!this.dialogData.postContent || !this.dialogData.postContent.trim()) &&
        flag
      ) {
        Message.error({ message: "文章内容不能为空" });
        flag = false;
      }
      return flag;
    },

    handleAddMember() {
      this.selectMemberVisible = true;
    },

    handleSavePostDraft() {
      //设置文章保存为草稿
      this.dialogData.isDraft = "1";
      this.loadingText = "保存中";
      this.handleSavePostInfo();
    },

    /**
     * 将tree格式的成员数据转化成偏平状的数据
     */
    delayeringMemberData() {
      this.dialogData.members = [];
      for (let member of this.members) {
        member.userId = member.id;
        this.dialogData.members.push(member);
      }
      // this.recursionMemberData(this.participant)
    },

    recursionMemberData(items) {
      for (let item of items) {
        if (item.isMember) {
          item.userId = item.id;
          this.members.push(JSON.parse(JSON.stringify(item)));
        }
        if (item.children && item.children.length !== 0) {
          this.recursionMemberData(item.children);
        }
      }
    },
    hasParticipant() {
      if (this.members.length === 0 && this.memberTips) {
        const h = this.$createElement;
        this.$confirm("提示", {
          message: h("p", null, [
            h(
              "p",
              { style: "font-size: 18px;line-height: 40px;" },
              "没有邀请参与人，是否继续发布？"
            )
          ]),
          distinguishCancelAndClose: true,
          confirmButtonText: "是",
          cancelButtonText: "否",
          type: "warning"
        })
          .then(() => {
            if (this.showProtocol) {
              this.protocolVisible = true;
            } else {
              this.handleSavePostInfo();
            }
          })
          .catch(action => {});
      } else {
        if (this.showProtocol) {
          this.protocolVisible = true;
        } else {
          this.handleSavePostInfo();
        }
      }
    },
    handleSavePostInfo() {
      this.$refs.majorContent.getArticleData(this.dialogData);


      if (this.hasMembers) {
        //将成员的数据设置到this.dialogData里面(从tree格式转化成扁平化方式的)
        this.delayeringMemberData();
      }

      if (!this.validateDialogForm()) {
        return;
      }
      if (!this.hasAttachment) {
        this.noAttachmentSave();
      } else {
        this.hasAttachmentSave();
      }
    },

    noAttachmentSave() {
      let members = [];
      if (this.hasMembers && this.dialogData.members) {
        members = this.dialogData.members.map(item => {
          return item.userId;
        });
      }

      let that = this;
      const encoder = new TextEncoder();
      const postContentLenght = encoder.encode(this.dialogData.postContent)
        .length;
      if (postContentLenght > 4000000000) {
        Message.warning(`${this.contentType}字数过长！`);
        return false;
      }
      this.isLoading = true;
      let obj = {
        token: cookie.getCookie("token"),
        data: {
          title: this.dialogData.postTitle,
          content: this.dialogData.postContent,
          isDraft: this.dialogData.isDraft,
          urgency: this.dialogData.urgency,
          members: members,
          priorityTpCode: this.priorityTpCode
        }
      };
      http
        .post(window.config.api.baseUrl + this.baseUrl, obj)
        .then(response => {
          if (response.data.code === "00000") {
            if (this.dialogData.isDraft === "1") {
              Message.success(`${this.contentType}草稿已保存`);
            } else {
              if (this.superPower || this.systemPower || this.deptPower) {
                Message.success(`${this.contentType}已经发布`);
              } else {
                Message.success(`{${this.contentType}已经提交审核}`);
              }
            }
            this.dialogData = this.$options.data().dialogData;
            //清空输入的数据
            this.$refs.majorContent.clearArticleData();
            this.$emit("refresh");
            //所有的操作都需要在关闭之前进行
            this.dialogVisible = false;
            //从首页点击发布时更新未读
            this.$store.dispatch("getUnreadTotal");
          } else {
            if (response.data.data.sensitiveWord) {
              that.$emit("sensitiveWord", response.data.data.sensitiveWord);
            }
          }
        })
        .finally(() => {
          this.$emit("refresh");
          that.isLoading = false;
          this.protocolVisible = false;
        });
    },

    hasAttachmentSave() {
      const encoder = new TextEncoder();
      const postContentLenght = encoder.encode(this.dialogData.postContent)
        .length;
      if (postContentLenght > 4000000000) {
        Message.warning("文章字数过长！");
        return false;
      }
      Message.info("数据导入可能需要几分钟,请耐心等待");
      let that = this;
      // 使用form表单的数据格式
      const paramsData = new FormData();
      this.dialogData.users = this.hasMembers
        ? JSON.parse(JSON.stringify(this.dialogData.members))
        : null;
      // 将上传文件数组依次添加到参数paramsData中
      this.dialogData.attachmentsMultipart.forEach((it, index) => {
        paramsData.append(`file`, it.file);
      });
      if (this.dialogData.attachmentsMultipart.length === 0) {
        paramsData.append(`file`, null);
      }
      let jsonData = {
        token: cookie.getCookie("token"),
        data: {
          attachment: this.dialogData.attachments,
          cd: this.discussAttachmentCode,

          article: {
            ...this.dialogData
          }
        }
      };
      //将表单数据添加到参数paramsData中,需要将参数转化成Blob后端才能识别到文件
      paramsData.append(
        "data",
        new Blob([JSON.stringify(jsonData)], { type: "application/json" })
      );
      // 表单数据和文件一起上传,调用后端接口
      this.isLoading = true;
      http
        .post(window.config.api.baseUrl + this.baseUrl, paramsData)
        .then(value => {
          if (value.data.code === "00000") {
            if (this.dialogData.isDraft === "1") {
              Message.success("文章草稿已保存");
            } else {
              if (this.superPower || this.systemPower || this.deptPower) {
                Message.success("文章已经发布");
              } else {
                Message.success("文章已经提交审核");
              }
            }
            //保存成功清除数据
            this.$refs.majorContent.clearArticleData();
            if (this.hasMembers) {
              this.$refs.memberContainer.clearMemberInviteInfo();
            }
            that.dialogData = this.$options.data().dialogData;
            this.$emit("refresh");
            this.dialogVisible = false;
            //从首页点击发布时更新未读
            this.$store.dispatch("getUnreadTotal");
          } else {
            if (value.data.data.sensitiveWord) {
              that.$emit("sensitiveWord", value.data.data.sensitiveWord);
            }
          }
        })
        .finally(() => {
          that.isLoading = false;
          this.protocolVisible = false;
        });
    },

    changePostCreateVisible(flag) {
      this.members = this.$options.data().members;
      this.participant = this.$options.data().participant;
      this.dialogData = this.$options.data().dialogData;
      //点击取消清空数据
      this.$refs.majorContent.clearArticleData();
      if (this.hasMembers) {
        this.$refs.memberContainer.clearMemberInviteInfo();
      }
      this.dialogVisible = flag;
    },

    handleCallback(data, checkNodes) {
      this.members = [];
      this.recursionMemberData(checkNodes);
      //过滤出成员
      this.members = this.members.filter(item => {
        return item.isMember;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.spec-dialog {
  .title-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    .title {
      flex: 1;
      justify-self: center;
    }
    .tips {
      flex: 1;
      justify-self: center;
      font-size: 15px;
    }
  }
  .content-panel {
    flex: 1;
    display: flex;
    flex-direction: row;
    height: 100%;
    .left-panel,
    .right-panel {
      margin: 0 10px;
    }
    .right-panel {
      display: flex;
      flex-direction: column;
      flex: 1;
    }
  }
  .dialog-footer {
    .operation-btn {
      margin: 0 10px;
    }
  }
}
.protocol-dialog {
  /deep/ .el-dialog__body {
    height: auto;
    .protocol-content {
      height: 50vh;
      overflow: auto;
      .info {
        width: 100%;
        text-indent: 2em;
        text-align: left;
      }
    }
  }
}
/deep/ .el-dialog--center {
  height: 80vh;
  /*设置弹窗dialog的默认高度*/
  min-height: 70vh;
  display: flex;
  flex-direction: column;
}

/deep/ .el-dialog__body {
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/detail/PostCreate.vue